import { Loader } from '@ui/components/Loader';

import {
  useDeleteNewsPostMutation,
  useNewsQuery,
  useSaveNewsPostMutation,
} from '@features/club/api/hooks';
import { ClubNewsListEdit } from '@features/club/ui/ClubNewsListEdit/ClubNewsListEdit';

type Props = {
  clubId: string;
};

export function ClubNewsListEditWidget({ clubId }: Props) {
  const { data: news, refetch } = useNewsQuery(clubId, 100);
  const { mutateAsync: onNewsSave } = useSaveNewsPostMutation(clubId);
  const { mutateAsync: onNewsDelete } = useDeleteNewsPostMutation(clubId);

  if (!news) return <Loader centered />;

  return (
    <ClubNewsListEdit
      news={news}
      onNewsSave={onNewsSave}
      onNewsDelete={onNewsDelete}
      refetch={refetch}
    />
  );
}
